<template>
    <div>
        <p><strong>{{ address.type.name }}</strong></p>
        <p>{{ address.street }} {{ address.house_number }}</p>
        <p>{{ address.zipcode }} {{ address.city }}</p>
        <p>{{ address.country.name }}</p>
    </div>
</template>
<script>
    export default {
        props: {
            address: {
                type: Object,
                required: true,
            }
        }
    }
</script>